import { AuthLayoutWrap } from './styles';
import type { AuthLayoutInterface } from './interface';

const AuthLayout = ({ children }: AuthLayoutInterface) => (
    <AuthLayoutWrap className="auth-layout">{children}</AuthLayoutWrap>
);

export default AuthLayout;
